// extracted by mini-css-extract-plugin
export default {"UserContainer":"UserMenu_UserContainer__cffwT","UserText":"UserMenu_UserText__UsA+g","UserName":"UserMenu_UserName__i1xpp","LogoutBtn":"UserMenu_LogoutBtn__uMq3s"};